// extracted by mini-css-extract-plugin
export default {"root":"_3b3Daczn1X6Irw8QHqRz-l","notificationsCode":"_1DqLbVWntGXCNCwMyTZ-2F"};